import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	height: 40px;
	background-color: ${colors.amber};
	cursor: default;
	padding: 0 32px;
	margin-top: 16px;
`;

export const HeaderLabel = styled.div`
	display: flex;
	padding: 0 16px;
	color: white;
	font-weight: 500;
	font-size: 13px;
	letter-spacing: 0.3px;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
`;

export const IconWrapper = styled.div`
	display: flex;
	cursor: pointer;
	transition: 0.15s transform ease-in-out;
	margin-left: auto;

	${({ isCollapsed }) =>
		!isCollapsed &&
		css`
			transform: rotate(180deg);
		`};
`;

export const List = styled.ul`
	overflow: auto;
	padding: 12px 24px 0 24px;
	max-height: 100px;
`;

export const ListItem = styled.li`
	color: ${colors.grey5};
	padding: 4px 0;
	font-size: 16px;
	line-height: 24px;
	min-height: 30px;
	display: flex;
	align-items: center;
	word-break: break-word;

	&:last-child {
		border-bottom: none;
	}

	&::before {
		content: '\\2022';
		color: ${colors.grey5};
		font-weight: bold;
		display: inline-block;
		margin-right: 8px;
		font-size: 14px;
		line-height: 24px;
		align-self: flex-start;
	}
`;
